import styled from '@emotion/styled';
import { themeGet } from '@styled-system/theme-get';

const getBackground = ({ theme, ctaTheme }) => {
  switch (ctaTheme) {
    case 'darkest-blue':
      return theme.color.colorBlueDarkest;
    default:
      return theme.color.colorBlue;
  }
};

export const StyledCTA = styled.div`
  position: relative;
  padding: ${themeGet('scale.scaleUp05')};
  text-align: center;
  color: ${themeGet('color.colorWhite')};
  background-color: ${getBackground};
  border-radius: ${themeGet('border.borderMedium')};
  box-shadow: 0 0 1px 0 rgba(68, 95, 140, 0.45),
    0 10px 29px -8px rgba(44, 74, 125, 0.34);

  @media (min-width: ${themeGet('breakpoint.breakpointMobile')}) {
    padding: ${themeGet('scale.scaleUp09')} ${themeGet('scale.scaleUp09')}
      ${themeGet('scale.scaleUp09')} 256px;
    text-align: left;
  }

  @media (min-width: ${themeGet('breakpoint.breakpointTablet')}) {
    padding: ${themeGet('scale.scaleUp09')};
    text-align: center;
  }

  h4 {
    color: white;
    font-size: ${themeGet('scale.scaleUp05')};
    line-height: ${themeGet('scale.scaleUp07')};

    @media (min-width: ${themeGet('breakpoint.breakpointTablet')}) {
      font-size: ${themeGet('scale.scaleUp07')};
    }
  }

  p {
    margin-bottom: ${themeGet('scale.scaleUp03')};
    font-size: ${themeGet('scale.scaleUp01')};
    line-height: ${themeGet('scale.scaleUp05')};

    @media (min-width: ${themeGet('breakpoint.breakpointTablet')}) {
      font-size: ${themeGet('scale.scaleUp02')};
    }
  }

  .btn-list {
    justify-content: flex-start;
    flex-direction: column;

    @media (min-width: ${themeGet('breakpoint.breakpointMobile')}) {
      flex-direction: row;
    }

    @media (min-width: ${themeGet('breakpoint.breakpointTablet')}) {
      justify-content: center;
    }
  }

  svg {
    display: none;
    position: absolute;
    top: 50%;
    left: ${themeGet('scale.scaleUp04')};
    margin-top: -62px;
    width: 180px;
    height: auto;

    @media (min-width: ${themeGet('breakpoint.breakpointMobile')}) {
      display: block;
    }

    @media (min-width: ${themeGet('breakpoint.breakpointTablet')}) {
      left: ${themeGet('scale.scaleUp12')};
    }

    @media (min-width: ${themeGet('breakpoint.breakpointDesktop')}) {
      left: ${themeGet('scale.scaleUp15')};
    }
  }
`;

export default StyledCTA;
